import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../../form/Checkbox'

class CheckboxCol extends PureComponent {
    onBlur = (obj) => {
        const { name, callback } = this.props
        callback(name, obj)
    }

    render() {
        const {
            title,
            grid,
            checkboxes,
            cssClass,
            inputType,
            id,
        } = this.props
        if (inputType) {
            return (
                <div {...grid} className={cssClass}>
                    <p className="optionHeaders">{title}</p>
                    {checkboxes && checkboxes.map((checkbox, i) => {
                        const label = checkbox.name === 'excludeNonNumeric' ? 'Exclude' : 'Lock question'
                        return (
                            <div
                                key={`${id}_${checkbox.value}`}
                                className="checkbox-icon hover-style "
                            >
                                <Checkbox
                                    id={id}
                                    onBlur={this.onBlur}
                                    label={label}
                                    name={checkbox.value}
                                    checked={checkbox.checked}
                                    className="exploriNativeCheckbox"
                                />
                            </div>
                        )
                    })}
                </div>
            )
        }
        return (
            <div {...grid} className={cssClass}>
                <p className="optionHeaders">{title}</p>
                {checkboxes && checkboxes.map((checkbox) => (
                    <Checkbox
                        key={`${id}_${checkbox.value}`}
                        id={id}
                        onBlur={this.onBlur}
                        label={checkbox.label}
                        name={checkbox.value}
                        checked={checkbox.checked}
                        className="exploriNativeCheckbox"
                    />
                ))}
            </div>
        )
    }
}

CheckboxCol.propTypes = {
    grid: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
}

export default CheckboxCol
